import { gql } from "apollo-boost";

export const GET_HOME_CLAIM_VALUATION = gql`
  query GetHomeClaimValuation($property_id: ID!) {
    home_claim_valuation(input: { property_id: $property_id }) {
      neighborhood_sale_price_per_sqft
      price_estimate_high
      price_estimate_low
      price_estimate_main
      price_estimate_per_sqft
      rent_estimate_main
      area_name
    }
  }
`;
